module.exports = __webpack_public_path__ + "media/images/step-recource---58a4ecf9fb3c1a5c5fb9324ae2a4909e.png";